import { render } from "./order_checkbox.vue?vue&type=template&id=0624152c&scoped=true"
import script from "./order_checkbox.vue?vue&type=script&lang=js"
export * from "./order_checkbox.vue?vue&type=script&lang=js"

import "./order_checkbox.vue?vue&type=style&index=0&id=0624152c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0624152c"]])

export default __exports__